import { render, staticRenderFns } from "./MatterRegionalCourtOfAppealList.vue?vue&type=template&id=f94cc902&"
import script from "./MatterRegionalCourtOfAppealList.vue?vue&type=script&lang=js&"
export * from "./MatterRegionalCourtOfAppealList.vue?vue&type=script&lang=js&"
import style0 from "./MatterRegionalCourtOfAppealList.vue?vue&type=style&index=0&id=f94cc902&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports